import React from 'react'
import instituition from '../../assets/icons/instituition.svg'
import bookHelp from '../../assets/icons/bookHelp.svg'
import bookHelp2 from '../../assets/icons/bookHelp2.svg'
import books from '../../assets/icons/books.svg'


const CourseReqTable = ({data}) => {

    const cleanText = (text) => {
       if (!text) return '';

       // Remove everything before the first curly brace
       let cleaned = text;
       const firstBraceIndex = text.indexOf('{');
       if (firstBraceIndex !== -1) {
         cleaned = text.slice(firstBraceIndex);
       }

       // Apply regex chain, including MS Word metadata
       return cleaned
         .replace(/{[^}]*}/g, '') // Remove curly braces and content
         .replace(
           /Normal\s+0\s+false\s+false\s+false\s+EN-US\s+X-NONE\s+X-NONE\s*\/\*.*?\*\/.*?(?:table\.MsoNormalTable)?|<[^>]*>|&nbsp;/gi,
           ' '
       ) // Remove MS Word metadata, HTML tags, and &nbsp;
         .replace(/â€˜Oâ€™/g, '') // Remove â€˜Oâ€™
         .replace(/â€˜Aâ€™/g, '') // Remove â€˜Oâ€™
         .replace(/&sq;Oâ€™/g, '') // Remove â€˜Oâ€™
         .replace(/&sq;A&sq;/g, '') // Remove â€˜Oâ€™
         .replace(/\s+/g, ' ') // Trim excess whitespace
         .replace(/,/g, ', ') // Add spaces after commas
         .trim(); // Remove leading/trailing spaces
    };
     
  return (
    <div className='relative flex flex-col items-center justify-start w-full'>
    
       <div className="overflow-x-auto w-full h-full no-scrollbar">
                <table className="table-auto border-collapse w-full rounded-lg border-none">
                <thead className=''>
                  <tr className='w-full rounded-lg'>
                    <th className="px-4 pt-4 pb-2 text-[11px] font-normal text-start text-[#808080] md:text-xs lg:font-medium xl:px-8 xl:pt-6 xl:text-sm">
                        <div className='flex items-center justify-start'>
                           <img className='w-3 md:w-3.5 lg:w-4 xl:w-5'
                           src={instituition} alt='inst_icon' />
                           <p className='w-[120px] ml-1.5 md:w-[75px] lg:w-[100px] xl:w-[110px]'>
                                Institutions
                           </p>
                        </div>
                    </th>

                    <th className="px-4 pt-4 pb-2 text-[11px] font-normal text-start text-[#808080] md:text-xs lg:font-medium xl:px-8 xl:pt-6 xl:text-sm">
                        <div className='flex items-center justify-start'>
                           <img className='w-3 md:w-3.5 lg:w-4 xl:w-5'
                           src={bookHelp} alt='inst_icon' />
                           <p className='w-[150px] ml-1.5 md:w-[75px] lg:w-[100px] xl:w-[120px]'>
                                 Direct Entry Requirements
                           </p>
                        </div>
                    </th>

                    <th className="px-4 pt-4 pb-2 text-[11px] font-normal text-start text-[#808080] md:text-xs lg:font-medium xl:px-8 xl:pt-6 xl:text-sm">
                        <div className='flex items-center justify-start'>
                           <img className='w-3 md:w-3.5 lg:w-4 xl:w-5'
                           src={bookHelp2} alt='inst_icon' />
                           <p className='w-[150px] ml-1.5 md:w-[75px] lg:w-[100px] xl:w-[200px]'>
                                 0'Level Requirements
                           </p>
                        </div>
                    </th>

                    <th className="px-4 pt-4 pb-2 text-[11px] font-normal text-start text-[#808080] md:text-xs lg:font-medium xl:px-8 xl:pt-6 xl:text-sm">
                        <div className='flex items-center justify-start'>
                           <img className='w-3 md:w-3.5 lg:w-4 xl:w-5'
                           src={books} alt='inst_icon' />
                           <p className='w-[150px] ml-1.5 md:w-[75px] lg:w-[100px] xl:w-[150px]'>
                                Subjects
                           </p>
                        </div>
                    </th>
                  </tr>
                </thead>


                <tbody>
                  <tr className='w-full bg-white'>
                    <td className="px-4 pt-3 border-t-[1px] border-[#DDE1E6] text-[10px] font-normal leading-[21px] align-top text-[#808080] md:text-[11px] lg:text-xs xl:px-8 xl:text-sm">
                         {data.title}
                    </td>

                    <td className="px-4 pt-3 border-t-[1px] border-[#DDE1E6] text-[10px] font-normal leading-[21px] align-top text-[#808080] md:text-[11px] lg:text-xs lg:leading-6 xl:leading-7 xl:px-8 xl:text-sm">
                         <p className='pb-1'>
                              {cleanText(data.de_requirements)}
                         </p>
                    </td>


                    <td className="px-4 pt-3 border-t-[1px] border-[#DDE1E6] text-[10px] font-normal leading-[21px] align-top text-[#808080] md:text-[11px] lg:text-xs lg:leading-6 xl:leading-7 xl:px-8 xl:text-sm">
                           <p className='pb-1'>
                               {cleanText(data.utme_requirements)}
                           </p>
                    </td>


                    <td className="px-4 pt-3 border-t-[1px] border-[#DDE1E6] text-[10px] font-normal leading-[21px] align-top text-[#808080] md:text-[11px] lg:text-xs lg:leading-6 xl:leading-7 xl:px-8 xl:text-sm">
                           <p className='pb-1'>
                                {cleanText(data.subjects)}
                           </p>
                    </td>
                    
                  </tr>
                  
                </tbody>

              </table>

         </div>

    </div>
  )
}

export default CourseReqTable
